import React, {useEffect} from 'react';
import styled from 'styled-components';
import AppRoutes from './AppRoutes';
const App = () => {
    function setScreenSize() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
    useEffect(() => {
        setScreenSize();
    });
    return(
  <Container>
    <AppRoutes/>
  </Container>
)
}
export default App;

const Container = styled.div`
    
`;